var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "600"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', [_vm._v("mdi-pencil")]), _vm._v(" " + _vm._s(_vm.edit ? "Editar" : "Cadastrar") + " Função ")], 1)]), _c('div', {
    staticClass: "container dialog"
  }, [_vm.visible ? _c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "justify-center mt-7"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome da Função*",
      "counter": "40",
      "maxlength": "40",
      "dense": "",
      "outlined": "",
      "rules": [function (v) {
        return _vm.$required(v);
      }, function (v) {
        return _vm.$max(v, 40);
      }]
    },
    model: {
      value: _vm.content.nome,
      callback: function ($$v) {
        _vm.$set(_vm.content, "nome", $$v);
      },
      expression: "content.nome"
    }
  }), _c('v-select', {
    attrs: {
      "label": "Tipo da Função*",
      "dense": "",
      "outlined": "",
      "item-value": "id",
      "item-text": "descricao",
      "items": _vm.tipos,
      "rules": [function (v) {
        return _vm.$required(v);
      }],
      "return-object": ""
    },
    model: {
      value: _vm.content.tipo,
      callback: function ($$v) {
        _vm.$set(_vm.content, "tipo", $$v);
      },
      expression: "content.tipo"
    }
  }), _c('v-textarea', {
    attrs: {
      "label": "Atividades Desempenhadas",
      "maxlength": "250",
      "counter": "250",
      "dense": "",
      "outlined": "",
      "rows": "4"
    },
    model: {
      value: _vm.content.descricao,
      callback: function ($$v) {
        _vm.$set(_vm.content, "descricao", $$v);
      },
      expression: "content.descricao"
    }
  })], 1)], 1)], 1) : _vm._e()], 1), _c('sigfoco-buttons', {
    attrs: {
      "actionText": "Salvar"
    },
    on: {
      "click": function ($event) {
        return _vm.salvar();
      },
      "cancel": function ($event) {
        return _vm.$emit('onClose');
      }
    }
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }